// Tooltip portal logic to prevent overflow clipping
// Moves .tooltiptext to <body> on hover and positions it absolutely
function tooltipFunction() {

    console.log('test');

    // Tooltip portal logic to prevent overflow clipping
    // Moves .tooltiptext to <body> on hover and positions it absolutely

    function isTooltipEvent(e, selector = '.tooltip') {
        // Only trigger if entering/leaving a .tooltip, not children
        const current = e.target.closest(selector);
        const related = e.relatedTarget && e.relatedTarget.closest(selector);
        return current && current !== related;
    }



    function showTooltipPortal(e) {
        if (!isTooltipEvent(e)) return;
        const tooltip = e.target.closest('.tooltip');
        if (!tooltip) return;
        const tooltipText = tooltip.querySelector('.tooltiptext');
        if (!tooltipText) return;
        if (tooltip._portalTooltip) return;

        // Create portal
        const portal = tooltipText.cloneNode(true);
        portal.classList.add('tooltiptext-portal');
        portal.style.position = 'absolute';
        portal.style.pointerEvents = 'none';
        portal.style.visibility = 'hidden';
        portal.style.zIndex = 9999;
        portal.style.minWidth = tooltipText.offsetWidth + 'px';
        document.body.appendChild(portal);

        // Wait for DOM paint to get correct size
        requestAnimationFrame(() => {
            const rect = tooltip.getBoundingClientRect();
            const portalRect = portal.getBoundingClientRect();
            // Center above the tooltip
            const left = rect.left + window.scrollX + rect.width / 2 - portalRect.width / 2;
            const top = rect.top + window.scrollY - portalRect.height - 8;
            portal.style.left = left + 'px';
            portal.style.top = top + 'px';
            portal.style.visibility = 'visible';
        });

        tooltipText.style.visibility = 'hidden';
        tooltip._portalTooltip = portal;
    }

    function hideTooltipPortal(e) {
        if (!isTooltipEvent(e)) return;
        const tooltip = e.target.closest('.tooltip');
        if (!tooltip) return;
        const tooltipText = tooltip.querySelector('.tooltiptext');
        if (!tooltipText) return;
        if (tooltip._portalTooltip) {
            tooltip._portalTooltip.remove();
            tooltip._portalTooltip = null;
        }
        tooltipText.style.visibility = '';
    }

    document.addEventListener('mouseover', showTooltipPortal, true);
    document.addEventListener('mouseout', hideTooltipPortal, true);


}

export default tooltipFunction;